import {
  ApplyFilter,
  ApplyFilterPayloadProps,
  ApplySort,
  ApplySortPayloadProps,
  DismissFilterPill,
  ResetFilter,
  SetColumn,
  SetColumnProps,
  SetData,
  SetSelection,
  SetDataProps,
  SetToggleAll,
  SetToggleAllProps,
  SetToggleItem,
  SetToggleItemProps,
} from './Table.interface';

// action types
export const APPLY_FILTER = 'APPLY_FILTER';
export const RESET_FILTER = 'RESET_FILTER';
export const DISMISS_FILTER_PILL = 'DISMISS_FILTER_PILL';
export const APPLY_SORT = 'APPLY_SORT';
export const SET_DATA = 'SET_DATA';
export const SET_COLUMN = 'SET_COLUMN';
export const SET_SELECTION = 'SET_SELECTION';
export const TOGGLE_ITEM = 'TOGGLE_ITEM';
export const TOGGLE_ALL = 'TOGGLE_ALL';

export const applyFilter = (payload: ApplyFilterPayloadProps): ApplyFilter => ({
  type: APPLY_FILTER,
  payload,
});

export const resetFilter = (): ResetFilter => ({
  type: RESET_FILTER,
});

export const setSelection = (payload: string[]): SetSelection => ({
  type: SET_SELECTION,
  payload,
});

export const dismissFilterPill = (payload: string): DismissFilterPill => ({
  type: DISMISS_FILTER_PILL,
  payload,
});

export const applySort = (payload: ApplySortPayloadProps): ApplySort => ({
  type: APPLY_SORT,
  payload,
});

export const setData = (payload: SetDataProps): SetData => ({
  type: SET_DATA,
  payload,
});

export const setColumn = (payload: SetColumnProps): SetColumn => ({
  type: SET_COLUMN,
  payload,
});

export const toggleItem = (payload: SetToggleItemProps): SetToggleItem => ({
  type: TOGGLE_ITEM,
  payload,
});

export const toggleAll = (payload: SetToggleAllProps): SetToggleAll => ({
  type: TOGGLE_ALL,
  payload,
});
